import React, {Component} from "react";
import {Modal} from "../../../../../components";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import DateUtil from "../../../../../utils/DateUtil";
import EnumAppointmentType from "../../../../appointment/enums/EnumAppointmentType";

export default class VisitSelectionModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedVisit: null
        };
    }

    dateTemplate = (visit) => {
        return visit.date ? DateUtil.formatDateTime12H(visit.date) : "";
    };

    typeTemplate = (visit) => {
        return visit.type && EnumAppointmentType[visit.type] ? EnumAppointmentType[visit.type].name : visit.type;
    };

    diagnosisTemplate = (visit) => {
        return <>{visit.diagnosis} {visit.diagnosisCode}</>;
    };

    render() {
        return (
            <Modal visible
                   id="visit-selection-modal"
                   header={this.props.header || "Select Visit"}
                   submitContent="Select"
                   submitDisabled={!this.state.selectedVisit}
                   submitAction={() => this.props.onSelect(this.state.selectedVisit)}
                   closeAction={this.props.close}
                   maxWidth={"lg"}>
                <DataTable id="VisitSelectionTable"
                           value={this.props.visitList}
                           selectionMode="single"
                           selection={this.state.selectedVisit}
                           onSelectionChange={(e) => this.setState({selectedVisit: e.value})}
                           emptyMessage={"There are no visits for this patient"}>
                    <Column field="date" header="Date" body={this.dateTemplate} style={{whiteSpace: "nowrap"}}/>
                    <Column field="provider" header="Provider" body={(visit) => visit.provider}
                            style={{whiteSpace: "nowrap"}}/>
                    <Column field="department" header="Speciality" body={(visit) => visit.department}
                            style={{whiteSpace: "nowrap"}}/>
                    <Column field="type" header="Type" body={this.typeTemplate}
                            style={{whiteSpace: "nowrap"}}/>
                    <Column field="diagnosis" header="Diagnosis" body={this.diagnosisTemplate}/>
                </DataTable>
            </Modal>
        );
    }
}
